module.exports = "\r\n.row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.label-color{\r\n    color: blue;\r\n}\r\n\r\n.border-view{\r\n    margin-top: 15px;\r\n    margin-bottom: 15px;\r\n    border: 1px solid gray;\r\n}\r\n\r\nspan{\r\n    font-weight: 700;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/depart-enquiry/enquiry-closure/enquiry-closer-form/enquiry-closer-form.component.css
// module id = ./src/app/hrms/depart-enquiry/enquiry-closure/enquiry-closer-form/enquiry-closer-form.component.css
// module chunks = main